import styled from 'styled-components';
import { Form as FormContainer } from '@unform/web';
import { shade } from 'polished';
import { SeparateLabel } from '../../../../components/SeparateLabel';
import { ButtonConfirm } from '../../../../components/ButtonConfirm';
import { ButtonSecurity } from '../../../../components/ButtonSecurity';
import { TextInfo } from '../../../../components/TextInfo';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const PageTitle = styled.h1`
  font-size: 40px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.02em;
  margin-bottom: 24px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 24px;
  align-items: start;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background-color: ${colors.surfaceContainerLow};
  border-radius: ${radius.lg};
  padding: 28px;
  margin-bottom: 24px;

  & > * {
    margin-bottom: 16px;
  }

  & > *:last-child {
    margin-bottom: 0;
  }
`;

export const ProfileName = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: ${colors.onSurface};
`;

export const ProfileRole = styled.span`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: ${colors.primary};
`;

export const Divider = styled.div`
  height: 1px;
  background-color: ${colors.outlineVariant}30;
`;

export const Form = styled(FormContainer)`
  display: flex;
  flex-direction: column;
`;

export const Info = styled(TextInfo)`
  margin: 10px 0;
`;

export const Row2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;

  @media (max-width: 1199px) {
    grid-template-columns: 1fr;
  }
`;

export const Separate = styled(SeparateLabel)``;

export const Confirm = styled(ButtonConfirm)`
  margin-top: 8px;
`;

export const ButtonDeleteAccount = styled(ButtonSecurity)`
  justify-content: center;
  background-color: ${colors.error};

  &:hover {
    background-color: ${shade(0.2, colors.error)};
  }

  span {
    font-weight: 700;
    color: ${colors.onError};
  }
`;
